import React, { useEffect, useRef, useState } from "react";
import trans from "../../../../utils";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import { Input } from "../../../Helpers/Input/Input";
import { Icon } from "leaflet";
import {
	Circle,
	MapContainer,
	Marker,
	Polygon,
	TileLayer,
	useMap,
	useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import MapLocationSearch from "../../../Maps/FeatureGroup/MapLocationSearch";
import POIsGeo from "./POIsGeo";
import { countries } from "../../../../utils/CountryState/countries";
import { state } from "../../../../utils/CountryState/states";
import { cities } from "../../../../utils/CountryState/cities";
import axios from "axios";
import { throttle } from "lodash";

const fetchGeoCodePosition = async (lat, lon) => {
	try {
		const response = await axios.get(
			`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`
		);
		return response?.data?.display_name || "Unknown location";
	} catch (error) {
		if (error.response?.status === 429) {
			console.error("Rate limit exceeded");
			return "Rate limit exceeded. Try again later.";
		}
		console.error("Error fetching geocode:", error);
		return "Failed to fetch location";
	}
};

// Throttled version outside the component
const useThrottledGeoCodeFetcher = () => {
	const throttled = useRef(
		throttle(async (lat, lon, setAddress) => {
			const result = await fetchGeoCodePosition(lat, lon);
			setAddress(result);
		}, 1000)
	).current;

	return throttled;
};

export default function POIsLocation({ addPOI }) {
	Icon.Default.mergeOptions({
		iconUrl: "https://www.svgrepo.com/show/513317/location-pin.svg",
	});
	const [location, setLocation] = useState({
		country: addPOI.values.country ? addPOI.values.country : null,
		state: addPOI.values.city ? addPOI.values.city : null,
		city: addPOI.values.state ? addPOI.values.state : null,
	});

	const [stateId, setStateId] = useState();
	const [position, setPosition] = useState(null);
	const [GeoCode, setGeoCode] = useState();
	const [diameter, setDiameter] = useState();
	const [active, setActive] = useState();
	const [polygonCoords, setPolygonCoords] = useState([]);
	const [latlng, setLatLng] = useState({ lat: null, lon: null, zoom: 6 });
	console.log("Locations", location);
	console.log("State Id", stateId);
	function capitalizeWords(str) {
		if (!str) return "";
		return str
			.split(" ")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ");
	}
	const sanitizeForSQL = (str) => {
		// Allow only letters, numbers, spaces, and basic punctuation like hyphens
		return str.replace(/[^a-zA-Z0-9\s\-]/g, "");
	};
	useEffect(() => {
		if (
			addPOI?.values?.country &&
			addPOI?.values?.city &&
			addPOI?.values?.state
		) {
			setLocation({
				country: addPOI.values.country,
				state: addPOI.values.city,
				city: addPOI.values.state,
			});
			const countryStates =
				state.find((s) => s.country === addPOI.values.country)?.states || [];
			console.log("countrystates", countryStates);
			const selected = countryStates.find(
				(i) => i.name.toLowerCase() === addPOI.values.city
			);
			console.log("selected city mo7afza", selected);
			if (selected) {
				setStateId(selected.id);
			}
		}
	}, [addPOI.values.city, addPOI.values.country, addPOI.values.state]);
	function LocationMarker() {
		useMapEvents({
			click(e) {
				setPosition(e.latlng);
				addPOI.setFieldValue("latitude", Number(e.latlng.lat));
				addPOI.setFieldValue("longitude", Number(e.latlng.lng));
			},
		});
		return position === null ? null : <Marker position={position}></Marker>;
	}
	// Outside the map, in your main form logic
	useEffect(() => {
		if (latlng.lat && latlng.lon) {
			addPOI.setFieldValue("latitude", Number(latlng.lat));
			addPOI.setFieldValue("longitude", Number(latlng.lon));
		}
	}, [latlng.lat, latlng.lon]);

	function MapFlyTo({ latlng }) {
		const map = useMap();

		useEffect(() => {
			if (latlng?.lat && latlng?.lon) {
				const zoom = latlng?.zoom ?? map.getZoom(); // use provided zoom or fallback
				map.flyTo([Number(latlng.lat), Number(latlng.lon)], zoom, {
					animate: true,
					duration: 1.5,
				});
			}
		}, [latlng.lat, latlng.lon, latlng.zoom, map]);

		return null;
	}

	function FlyToGeo({ area, diameter }) {
		const map = useMap();

		useEffect(() => {
			if (!area || !diameter) return;

			const coordsString = area
				.replace("POLYGON ((", "")
				.replace("))", "")
				.trim();

			const coords = coordsString
				.split(",")
				.map((pair) => {
					const [lat, lng] = pair.trim().split(" ").map(Number);
					return Number.isFinite(lat) && Number.isFinite(lng)
						? [lat, lng]
						: null;
				})
				.filter(Boolean);

			if (coords.length === 0) return; // 🚫 bail on invalid

			const bounds = L.latLngBounds(coords);
			const center = bounds.getCenter();

			// Diameter guard too
			if (!Number.isFinite(diameter) || diameter <= 0) return;

			const zoom = 18 - Math.log2(diameter / 50);
			const clampedZoom = Math.min(18, Math.max(12, zoom));

			map.flyTo(center, clampedZoom, { duration: 1.5 });
		}, [area, diameter, map]);

		return null;
	}

	useEffect(() => {
		const lat = parseFloat(addPOI.values.latitude);
		const lng = parseFloat(addPOI.values.longitude);
		const rad = parseFloat(addPOI.values.diameter);
		if (
			!Number.isFinite(lat) ||
			!Number.isFinite(lng) ||
			!Number.isFinite(rad) ||
			rad <= 0 ||
			Math.abs(lat) > 90 ||
			Math.abs(lng) > 180
		) {
			return;
		}

		const isValid =
			!isNaN(lat) &&
			!isNaN(lng) &&
			!isNaN(rad) &&
			rad > 0 &&
			Math.abs(lat) <= 90 &&
			Math.abs(lng) <= 180;

		if (!isValid) return;

		const radius = rad / 2;
		const EARTH_RADIUS = 6371000; // meters

		// --- Bounding Box (optional, still useful) ---
		const deltaLat = (radius / EARTH_RADIUS) * (180 / Math.PI);
		const deltaLng =
			((radius / EARTH_RADIUS) * (180 / Math.PI)) /
			Math.cos((lat * Math.PI) / 180);

		const bounds = {
			minLat: lat - deltaLat,
			maxLat: lat + deltaLat,
			minLng: lng - deltaLng,
			maxLng: lng + deltaLng,
		};

		console.log("Safe Bounding Box:", bounds);

		// --- Dodecagon Generator ---
		const sides = 12; // Dodecagon
		const angleStep = 360 / sides;
		const points = [];

		const toRadians = (deg) => (deg * Math.PI) / 180;
		const toDegrees = (rad) => (rad * 180) / Math.PI;

		const destinationPoint = (lat, lng, distance, bearing) => {
			const δ = distance / EARTH_RADIUS;
			const θ = toRadians(bearing);

			const φ1 = toRadians(lat);
			const λ1 = toRadians(lng);

			const φ2 = Math.asin(
				Math.sin(φ1) * Math.cos(δ) + Math.cos(φ1) * Math.sin(δ) * Math.cos(θ)
			);

			const λ2 =
				λ1 +
				Math.atan2(
					Math.sin(θ) * Math.sin(δ) * Math.cos(φ1),
					Math.cos(δ) - Math.sin(φ1) * Math.sin(φ2)
				);

			return {
				lat: toDegrees(φ2),
				lng: toDegrees(λ2),
			};
		};

		for (let i = 0; i < sides; i++) {
			const bearing = i * angleStep;
			const point = destinationPoint(lat, lng, radius, bearing);
			points.push(point);
		}
		points.push(points[0]); // close polygon
		setPolygonCoords(points);
		const polygonWKT = `POLYGON ((${points
			.map((p) => `${p.lat} ${p.lng}`)
			.join(", ")}))`;

		console.log("Dodecagon WKT:", polygonWKT);
		addPOI.setFieldValue("area", polygonWKT);
		// Optionally store in state/form:
		// setFieldValue("geofencePolygon", polygonWKT);
		// setPolygonCoords(points);
	}, [addPOI.values.latitude, addPOI.values.longitude, addPOI.values.diameter]);

	useEffect(() => {
		const lat = addPOI.values.latitude;
		const lng = addPOI.values.longitude;

		const isValidNumber = (val) => {
			if (typeof val !== "string" && typeof val !== "number") return false;
			const trimmed = val.toString().trim();
			return trimmed !== "" && !isNaN(Number(trimmed));
		};

		if (isValidNumber(lat) && isValidNumber(lng)) {
			setPosition({
				lat: parseFloat(lat),
				lng: parseFloat(lng),
			});
		} else {
			setPosition(null);
		}
	}, [addPOI.values.latitude, addPOI.values.longitude]);

	const throttledFetcher = useThrottledGeoCodeFetcher();
	useEffect(() => {
		const { latitude, longitude } = addPOI.values;
		if (latitude && longitude) {
			throttledFetcher(
				addPOI?.values?.latitude,
				addPOI?.values?.longitude,
				(resolvedAddress) => {
					addPOI.setFieldValue("address", resolvedAddress);
					setGeoCode(resolvedAddress);
				}
			);
		}
	}, [addPOI.values.latitude, addPOI.values.longitude]);
	useEffect(() => {
		if (!active) {
			setDiameter(null);
		}
	}, [active]);
	useEffect(() => {
		if (addPOI.values.state && !stateId) {
			const countryStates =
				state.find((s) => s.countryName === location.country)?.states ||
				state.find((s) => s.country === location.country)?.states;

			const selectedState = countryStates?.find(
				(s) => s.name.toLowerCase() === addPOI.values.state
			);
			console.log("countryStates", countryStates);
			console.log("selected STTTATE", selectedState);
			if (selectedState) {
				setStateId(selectedState.id);
			}
		}
	}, [addPOI.values.state, state, stateId, location.country]);

	return (
		<>
			<p className="fs-16 fw-500 brand-700 text-capitalize">
				{trans("Region/Zone/Territory")}
			</p>
			<div className="row">
				<div className="col-lg-4">
					<InputSelect
						label="Country"
						name="country"
						id="country"
						placeholder={trans("Select Country")}
						onBlur={addPOI.handleBlur}
						onChange={(value) => {
							addPOI.setFieldValue("country", value);
							setLocation({ country: value, state: null, city: null });
							setStateId(undefined); // reset stateId as country changed
							const country = countries.find((i) => i.name === value);
							if (country)
								setLatLng({
									lat: country.latitude,
									lon: country.longitude,
									zoom: 6,
								});
							if (addPOI.values.state && addPOI.values.city) {
								addPOI.setFieldValue("state", null);
								addPOI.setFieldValue("city", null);
							}
						}}
						value={
							addPOI.values.country
								? capitalizeWords(addPOI.values.country)
								: undefined
						}
						touched={addPOI.touched.country}
						errors={addPOI.errors.country}
						options={countries?.map((i) => ({
							label: trans(i.name),
							value: i.name,
						}))}
						formstyle="form-input"
					/>
				</div>
				<div className="col-lg-4">
					<InputSelect
						label="State"
						name="state"
						id="state"
						placeholder={trans("Select State")}
						onBlur={addPOI.handleBlur}
						onChange={(value) => {
							addPOI.setFieldValue("state", value);
							addPOI.setFieldValue("city", ""); // ✅ Clear city on state change
							setLocation((prev) => ({ ...prev, state: value, city: "" }));
							const countryStates =
								state.find((s) => s.countryName === location.country)?.states ||
								state.find((s) => s.country === location.country)?.states;
							console.log("Country States", countryStates);
							const selected = countryStates.find(
								(i) => sanitizeForSQL(i.name) === value
							);

							console.log("selected city mo7afza", selected);
							if (selected) {
								setLatLng({
									lat: selected.lat,
									lon: selected.lon,
									zoom: 10,
								});
								console.log("Selected", selected);
								setStateId(selected.id);
							}
						}}
						value={
							addPOI.values.country && capitalizeWords(addPOI.values.state)
						}
						touched={addPOI.touched.state}
						errors={addPOI.errors.state}
						options={
							state
								.find(
									(i) =>
										i.countryName === location.country ||
										i.country === addPOI.values.country
								)
								?.states?.map((i) => ({
									label: trans(i.name),
									value: sanitizeForSQL(i.name),
								})) || []
						}
						formstyle="form-input"
					/>
				</div>
				<div className="col-lg-4">
					<InputSelect
						label="City"
						name="city"
						id="city"
						placeholder={trans("Select City")}
						onBlur={addPOI.handleBlur}
						onChange={(value) => {
							addPOI.setFieldValue("city", value); // setting selected city
							setLocation((prev) => ({ ...prev, city: value }));

							let foundState = null;
							let foundCity = null;

							// Find state that contains the city with name === value
							cities?.forEach((country) => {
								country.states?.forEach((state) => {
									const city = state.cities?.find(
										(c) => sanitizeForSQL(c.name) === value
									);
									if (city) {
										foundState = state;
										foundCity = city;
									}
								});
							});

							if (foundState && foundCity) {
								setStateId(foundState.id);
								setLatLng({
									lat: foundCity.latitude,
									lon: foundCity.longitude,
									zoom: 14,
								});
							}
						}}
						touched={addPOI.touched.city}
						errors={addPOI.errors.city}
						options={
							cities?.flatMap((i) => {
								const matchedState = i.states?.find(
									(stateItem) => stateItem.id === stateId
								);
								console.log("matched data", matchedState);
								return (
									matchedState?.cities?.map((city) => ({
										label: trans(city.name),
										value: sanitizeForSQL(city.name),
									})) || []
								);
							}) || []
						}
						value={addPOI.values.city && capitalizeWords(addPOI.values.city)}
						formstyle="form-input"
					/>
				</div>
			</div>
			<p className="fs-16 fw-500 brand-700 text-capitalize">
				{trans("location selection")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<Input
						title={trans("latitude")}
						type="text"
						placeholder={trans("Enter Latitude")}
						id="latitude"
						name="latitude"
						formstyle="form-input"
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(e) => addPOI.handleChange(e)}
						errors={addPOI.errors.latitude}
						touched={addPOI.touched.latitude}
						value={addPOI.values.latitude || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("longitude")}
						type="text"
						placeholder={trans("Enter Longitude")}
						id="longitude"
						name="longitude"
						formstyle="form-input"
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(e) => addPOI.handleChange(e)}
						errors={addPOI.errors.longitude}
						touched={addPOI.touched.longitude}
						value={addPOI.values.longitude || ""}
					/>
				</div>
			</div>
			<POIsGeo
				setDiameter={setDiameter}
				setActive={setActive}
				active={active}
				addPOI={addPOI}
			/>
			<p className="form-label text-capitalize">
				{trans("Interactive map for location selection")}
			</p>

			<MapContainer
				center={
					addPOI?.values?.longitude && addPOI?.values?.latitude
						? [addPOI?.values?.latitude, addPOI?.values?.longitude]
						: [23.8859, 45.0792]
				} // Update center when position changes
				zoom={5}
				minZoom={3}
				maxZoom={18}
				style={{ height: "300px", width: "100%", borderRadius: "8px" }}
			>
				<TileLayer url="https://mt0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}" />
				<MapFlyTo latlng={latlng} />
				<MapLocationSearch />
				<FlyToGeo area={addPOI.values.area} diameter={addPOI.values.diameter} />
				<LocationMarker />
				{addPOI.values.diameter && addPOI.values.geofenced && (
					<Polygon
						positions={polygonCoords.map((p) => [p.lat, p.lng])}
						pathOptions={{ color: "#2E9245", fillOpacity: 0.2 }}
					/>
				)}
			</MapContainer>
			<p style={{ color: "#2E9245" }}>
				{GeoCode
					? sanitizeForSQL(GeoCode)
					: trans("Address of the selected location")}
			</p>
		</>
	);
}
